import { BookOpenText, Summary, WholeWord } from 'lucide-react'
import { Tabs } from '@highlight/ui'

interface MeetingViewTabBarProps {
  /** A Custom Meeting has no brief to offer, so it gets no empty tab. */
  hasBriefTab: boolean
}

/** Brief | Transcript | Recap. The panels it drives live in `body.tsx`. */
export function MeetingViewTabBar({ hasBriefTab }: MeetingViewTabBarProps) {
  return (
    <Tabs.List aria-label="Meeting" data-tour-section="meeting-tabs">
      {hasBriefTab && (
        <Tabs.Tab value="brief">
          <BookOpenText aria-hidden="true" className="size-3.5" />
          Brief
        </Tabs.Tab>
      )}
      <Tabs.Tab value="transcript">
        <WholeWord aria-hidden="true" className="size-3.5" />
        Transcript
      </Tabs.Tab>
      <Tabs.Tab value="recap">
        <Summary aria-hidden="true" className="size-3.5" />
        Recap
      </Tabs.Tab>
    </Tabs.List>
  )
}
